
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116 45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFFFFE","fill-rule":"evenodd","d":"M115.684 39.936c0-6.754-5.474-12.227-12.227-12.227-2.217 0-4.294.592-6.087 1.624-1.275-8.202-8.367-14.48-16.926-14.48-1.658 0-3.258.24-4.775.679C72.75 6.519 64.29 0 54.303 0 43.704 0 34.826 7.343 32.465 17.219a6.517 6.517 0 00-1.493-.18 6.517 6.517 0 00-6.518 6.518 6.5 6.5 0 00.216 1.634c-4.862.56-9.007 3.466-11.275 7.559a12.499 12.499 0 00-1.168-.057C5.474 32.693 0 38.168 0 44.92h114.621a12.172 12.172 0 001.063-4.984z"}})])
          )
        }
      }
    